import React, { useState, Suspense, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    createStyles,
    ActionIcon,
    Button,
    Collapse,
    Select,
    TextInput,
    NumberInput,
    Switch,
    Radio,
    SegmentedControl,
    Card,
    Paper,
    Avatar,
    Group,
    TypographyStylesProvider,
    Text
} from '@mantine/core';
import {
    DatePicker,
    DateRangePicker,
    TimeInput
} from '@mantine/dates';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import {
  IconBell,
  IconSettings,
  IconUsers,
  IconFileSettings,
  IconUserPlus,
  IconGavel,
  IconBuildingBank,
  IconRepeat,
  IconReceiptRefund,
  IconReceipt,
  IconReceiptTax,
  IconReport,
  IconCashBanknote,
  IconBook,
  IconCalendar,
  IconMessage,
} from '@tabler/icons';


import { 
    carCreatorTextInfoUpdated,
    carCreatorSelectSectionDataB,
    fetchTests,
    testPost,
    testUpload,
    selectImage
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';
import { 
    fieldInfoUpdated,
    selectSectionData,
} from '../features/home/homeSlice';
//descript:here for upload tests
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    },
    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
    
}));


//needed: props
const MsgsItem = () => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    
    const component_md = {
        par: 'msgs',
        lvl: 0,
        child: 'all',
        section: 'all',
    }
    const msg = "friend_A: Hey lets catch up soon it's been way too long!"


    return (
        <>
                <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Group position="apart">
                            {/*<Avatar src={black_and_white_mercedes_benz} radius="xl" />*/}
                            <Avatar.Group spacing="sm">
                                <Avatar src={pagani} radius="xl" />
                                <Avatar src={black_and_white_mercedes_benz} radius="xl" />
                                <Avatar radius="xl" color="green">GG</Avatar>
                                <Avatar radius="xl">+5</Avatar>
                            </Avatar.Group>

                            <Text fz="sm">Title</Text>
                        </Group>
                        <br/>
                        <Text fz="xs" c="dimmed">
                            May 25th, 2023 @ 09:00PM PST
                        </Text>
                        <TypographyStylesProvider className={classes.body}>
                            <div className={classes.content} dangerouslySetInnerHTML={{ __html: msg }} />
                        </TypographyStylesProvider>
                    <br/>
                </Card>
        </>
    );
    
}
export default MsgsItem
